
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateCalculationitemPropertyDtoFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    propertyName: new FormControl<string | undefined>('', [Validators.required]),
    propertyValue: new FormControl<any | undefined>(undefined, [Validators.required]),
})
;
}
      